import { useTranslation } from 'react-i18next'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

import ActionsContainer from '@/components/ActionsContainer'
import * as constants from '@/constants'

import { getDisplayReturnOptions } from './helpers'

const TransactionButtons = ({
  allowedTransactionTypes,
  isFormValid,
  orderLoading,
  returnIsLoading,
  exchangeIsLoading,
  handleSubmit,
  allowsUnifiedFlow,
  isGiftReturn,
}) => {
  const { t } = useTranslation()

  return (
    <ActionsContainer manyButtons={getDisplayReturnOptions(allowedTransactionTypes)}>
      {allowsUnifiedFlow ? (
        <ButtonWithSpinner
          onClick={e => handleSubmit(e, constants.orderTransactionTypes.mixed)}
          type="submit"
          disabled={!isFormValid() || orderLoading}
          loading={orderLoading}
          loadingLabel={isGiftReturn ? t('Buscando pedido del regalo') : t('Buscando pedido')}
          defaultLabel={isGiftReturn ? t('Buscar pedido del regalo') : t('Buscar pedido')}
        ></ButtonWithSpinner>
      ) : (
        <>
          {allowedTransactionTypes?.includes(constants.orderTransactionTypes.exchange) && (
            <ButtonWithSpinner
              onClick={e => handleSubmit(e, constants.orderTransactionTypes.exchange)}
              type="button"
              disabled={!isFormValid() || orderLoading}
              loading={exchangeIsLoading}
              loadingLabel={t('Procesando')}
              defaultLabel={t('Cambiar productos')}
            ></ButtonWithSpinner>
          )}
          {allowedTransactionTypes?.includes(constants.orderTransactionTypes.refund) && (
            <ButtonWithSpinner
              type="submit"
              disabled={!isFormValid() || orderLoading}
              defaultLabel={t('Devolver productos')}
              loadingLabel={t('Procesando')}
              loading={returnIsLoading}
            ></ButtonWithSpinner>
          )}
        </>
      )}
    </ActionsContainer>
  )
}

export default TransactionButtons
